<template>
  <transition name="fade">
    <div
      v-show="isActive"
      class="fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-black bg-opacity-50 py-4 z-50"
      @click="skip"
    >
      <div
        class="w-full max-w-md max-h-full h-auto text-gray-900 bg-gray-100 rounded-lg p-4 overflow-auto"
        @click.stop="() => {}"
      >
        <div class="flex flex-col gap-3">
          <button class="ml-auto" @click="skip">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-6 h-6"
            >
              <path
                fill-rule="evenodd"
                d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <div class="uppercase text-center text-sm text-gray-700">Before you start</div>
          <div class="text-center text-xs text-gray-600">
            Enter a name for Endless highscores (optional).
          </div>

          <input
            ref="nameInput"
            v-model="playerNameInput"
            type="text"
            maxlength="64"
            placeholder="Your name"
            class="w-full px-3 py-2 rounded bg-white text-gray-900 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black/20"
            @keydown.enter.prevent="continueToGame"
          />

          <div v-if="error" class="text-center text-xs text-red-700">
            {{ error }}
          </div>

          <div class="flex gap-2 justify-center">
            <button class="px-3 py-2 rounded bg-gray-200 text-gray-900 text-sm" @click="skip">
              Skip
            </button>
            <button class="px-3 py-2 rounded bg-black text-white text-sm" @click="continueToGame">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import { socket } from "../../main";

export default {
  name: "EndlessNameModal",

  data() {
    return {
      playerNameInput: "",
      error: "",
    };
  },

  computed: {
    ...mapGetters({
      activeModal: "getActiveModal",
    }),

    isActive() {
      return this.activeModal === "endless_name_modal";
    },
  },

  watch: {
    isActive(newValue) {
      if (!newValue) return;
      this.error = "";
      this.playerNameInput = (window.localStorage.getItem("endlessPlayerName") || "").trim();

      this.$nextTick(() => {
        const el = this.$refs.nameInput;
        if (el && typeof el.focus === "function") el.focus();
      });
    },
  },

  methods: {
    startEndlessWithName(name) {
      const normaliseStoredValue = (value) => {
        if (value == null) return null;
        if (value === "" || value === "null" || value === "undefined") return null;
        return value;
      };

      const storedPlayerId = normaliseStoredValue(window.localStorage.getItem("playerId"));
      const storedGameId = normaliseStoredValue(window.localStorage.getItem("gameId"));

      socket.emit("startEndless", storedPlayerId, storedGameId, name || null);
    },

    skip() {
      this.$store.commit("setActiveModal", "");
      this.startEndlessWithName(null);
    },

    continueToGame() {
      this.error = "";
      const trimmed = (this.playerNameInput || "").trim().slice(0, 64);

      if (trimmed) {
        window.localStorage.setItem("endlessPlayerName", trimmed);
      }

      this.$store.commit("setActiveModal", "");
      this.startEndlessWithName(trimmed || null);
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/EndlessNameModal.vue